import { AdvSearchFilter } from '@components/constants';
import { Lookup } from '@core/services/models/shared/lookup';

export enum QualificationStatus {
  All = AdvSearchFilter.All,
  Draft = 1001,
  Current = 1002,
  Expiring = 1003,
  Discontinued = 1004,
  Withdrawn = 1005,
  Declined = 1006
}

export class QualificationStatusString {
  public static get(status: QualificationStatus): string {
    switch (status) {
      case QualificationStatus.All:
        return 'All';
      case QualificationStatus.Draft:
        return 'Draft';
      case QualificationStatus.Current:
        return 'Current';
      case QualificationStatus.Expiring:
        return 'Expiring';
      case QualificationStatus.Discontinued:
        return 'Discontinued';
      case QualificationStatus.Withdrawn:
        return 'Withdrawn';
      case QualificationStatus.Declined:
        return 'Declined';
    }
  }
}

export enum QualificationVersionStatusEnum {
  All = AdvSearchFilter.All,
  Draft = 1050,
  Approved = 1051,
  Superseded = 1052,
  Withdrawn = 1053,
  Declined = 1054,
  Discontinued = 1055,
  Expiring = 1056
}

export enum PrimaryLanguage {
  English = 1302,
  Maori = 1301
}

export enum QualityAssuranceBodies {
  CommitteeOfUniversityAcademicProgrammes = 1200,
  NewZealandQualificationsAuthority = 1201,
  CollegesOfEducationAccreditationCommittee = 1202,
  QualityAssuranceDivisionNZQA = 1203,
  InstitutesOfTechnologyAndPolytechnicsQuality = 1204
}

export enum QualificationTypes {
  All = AdvSearchFilter.All,
  BachelorsDegree = 1100,
  BachelorHonoursDegree = 1101,
  Certificate = 1102,
  Diploma = 1103,
  DoctoralDegree = 1104,
  GraduateCertificate = 1105,
  GraduateDiploma = 1106,
  MastersDegree = 1107,
  PostgraduateCertificate = 1108,
  PostgraduateDiploma = 1109
}

export enum QualificationCategories {
  EducationOrganisationDevelopedQualification = 1250,
  LocalQualification = 1251,
  LegislatedWanangaQualification = 1252,
  NationalQualification = 1253,
  NewZealandQualification = 1254
}

export enum QualificationFundingStatusEnum {
  Approved = 1501,
  NotApproved = 1502,
  ApprovalWithdrawn = 1503
}
export const QualificationFundingStatusLookup: Lookup<number>[] = [
  { text: 'Approved', value: QualificationFundingStatusEnum.Approved },
  { text: 'Not Approved', value: QualificationFundingStatusEnum.NotApproved },
  { text: 'Approval Withdrawn', value: QualificationFundingStatusEnum.ApprovalWithdrawn }
];
export enum QualificationStudentLoanBorrowingEnum {
  Approved = 1601,
  NotApproved = 1602,
  ApprovalWithdrawn = 1603
}
export const QualificationStudentLoanBorrowingLookup: Lookup<number>[] = [
  { text: 'Approved', value: QualificationStudentLoanBorrowingEnum.Approved },
  { text: 'Not Approved', value: QualificationStudentLoanBorrowingEnum.NotApproved },
  { text: 'Approval Withdrawn', value: QualificationStudentLoanBorrowingEnum.ApprovalWithdrawn }
];
export enum QualificationEligStudentLoanAllowanceEnum {
  Approved = 1701,
  NotApproved = 1702,
  ApprovalWithdrawn = 1703
}
export const QualificationEligStudentLoanAllowanceLookup: Lookup<number>[] = [
  { text: 'Approved', value: QualificationEligStudentLoanAllowanceEnum.Approved },
  { text: 'Not Approved', value: QualificationEligStudentLoanAllowanceEnum.NotApproved },
  { text: 'Approval Withdrawn', value: QualificationEligStudentLoanAllowanceEnum.ApprovalWithdrawn }
];

// These are the levels that NZQA recognises for qualifications within New Zealand.
// The levels correspond to levels of acheivement and qualification internationally.
export const LevelOptions: Lookup<number>[] = [
  { value: 1, text: '1' },
  { value: 2, text: '2' },
  { value: 3, text: '3' },
  { value: 4, text: '4' },
  { value: 5, text: '5' },
  { value: 6, text: '6' },
  { value: 7, text: '7' },
  { value: 8, text: '8' },
  { value: 9, text: '9' },
  { value: 10, text: '10' }
];
